import FlexComponent from "./FlexComponent";

export default FlexComponent;
